import { Copy, ExternalLink } from 'lucide-react'
import { toast } from 'sonner'
import { cn, shortAddress } from '@/lib/utils'
import { explorerUrl } from '@/config/chains'

interface Props {
    address?: string
    chainId?: number
    truncate?: boolean
    className?: string
}

export function AddressDisplay({ address, chainId, truncate = true, className }: Props) {
    if (!address) return <span className="text-muted-foreground">—</span>
    const display = truncate ? shortAddress(address) : address
    const link = chainId ? explorerUrl(chainId, 'address', address) : undefined

    return (
        <span className={cn('inline-flex items-center gap-1.5 font-mono text-sm', className)}>
            <span>{display}</span>
            <button
                type="button"
                className="text-muted-foreground hover:text-foreground"
                onClick={() => {
                    navigator.clipboard.writeText(address)
                    toast.success('Address copied')
                }}
                aria-label="Copy address"
            >
                <Copy className="h-3.5 w-3.5" />
            </button>
            {link && (
                <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-muted-foreground hover:text-foreground"
                    aria-label="View on explorer"
                >
                    <ExternalLink className="h-3.5 w-3.5" />
                </a>
            )}
        </span>
    )
}
